module.exports = __webpack_public_path__ + "234b-img-box.png";